import { StyleSheet } from '@react-pdf/renderer';
import { colors } from 'commons/src/constants';

const iaqInsight2PdfStyles = StyleSheet.create({
    page: {
        paddingTop: '6vw',
        paddingRight: '5vw',
        paddingBottom: '75',
        paddingLeft: '5vw',
        fontFamily: 'Regular',
    },
    headerTitleRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '16',
    },
    headerLogoContainer: {
        width: '120',
        height: '60',
        marginLeft: '20',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerLogo: {
        maxWidth: '120',
        maxHeight: '60',
        objectFit: 'contain',
    },
    headerText: {
        fontSize: 25,
        fontFamily: 'DemiBold',
        maxWidth: '60vw',
    },
    headerBlock: {
        marginBottom: '3vw',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    reportTitle: {
        fontSize: 24,
        fontFamily: 'DemiBold',
        color: '#21282D',
        marginBottom: 0,
    },
    introParagraph: {
        fontSize: '11',
        fontFamily: 'Regular',
        color: '#21282D',
        lineHeight: 1.5,
        marginBottom: '32',
    },
    buildingName: {
        fontSize: 20,
        fontFamily: 'DemiBold',
        marginBottom: '0.5vw',
        color: '#21282D',
    },
    buildingAddress: {
        fontSize: 14,
        fontFamily: 'Regular',
        color: '#8C9BA8',
        marginBottom: '32',
    },
    sectionTitle: {
        fontSize: 20,
        fontFamily: 'DemiBold',
        marginTop: '0',
        marginBottom: '32',
        color: '#21282D',
    },
    airQualityAveragesDescription: {
        fontSize: '11',
        fontFamily: 'Regular',
        color: '#21282D',
        lineHeight: 1.5,
        marginBottom: '32',
    },
    logoContainer: {
        height: '12vw',
        display: 'flex',
        marginTop: '-5px',
        marginRight: '4vw',
        width: '30vw',
        justifyContent: 'flex-start',
    },
    paragraph: {
        fontSize: 11,
        fontFamily: 'Regular',
        fontStyle: 'normal',
        fontWeight: 400,
        marginTop: '0',
        marginBottom: '32',
        color: '#21282D',
        lineHeight: 1.5,
    },
    subHeader: {
        fontSize: '13',
        marginTop: '32',
        marginBottom: '2vw',
    },
    subHeaderNoMargin: {
        fontSize: '13',
    },
    boldText: {
        fontFamily: 'DemiBold',
    },
    smallText: {
        fontSize: 10,
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap',
        maxWidth: '80%',
        textAlign: 'left',
    },
    colorRed: {
        backgroundColor: colors.redPersian,
    },
    colorGreen: {
        backgroundColor: colors.greenBiosphere,
    },
    colorYellow: {
        backgroundColor: colors.yellowSunlight,
    },
    textColorRed: {
        color: colors.redPersian,
    },
    textColorGreen: {
        color: colors.greenBiosphere,
    },
    coloredCircle: {
        minWidth: '10',
        height: '50',
        width: '50',
        marginTop: '2',
        border: '5 solid gray',
        borderRadius: '25',
        position: 'relative',
    },
    coloredCircleRed: {
        borderColor: colors.redPersian,
    },
    coloredCircleGreen: {
        borderColor: colors.greenBiosphere,
    },
    coloredCircleYellow: {
        borderColor: colors.yellowSunlight,
    },
    coloredCircleGrey: {
        borderColor: colors.greyMist,
    },
    smallCircle: {
        height: '28px',
        width: '28px',
        borderWidth: 3.5,
        marginRight: '5px',
    },
    coloredDot: {
        minWidth: '10',
        height: '10',
        width: '10',
        marginTop: '2',
        marginLeft: '8',
        marginRight: '9',
        borderRadius: '9',
    },
    flexWrapper: {
        display: 'flex',
        flexDirection: 'row',
    },
    flexWrapperSpaced: {
        display: 'flex',
        flexDirection: 'row',
        fontSize: '10',
        justifyContent: 'space-between',
    },
    flexWrapperWrapped: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    insightWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    pageLine: {
        borderTop: `1 solid ${colors.greyMist}`,
        marginTop: '2vw',
        marginBottom: '2vw',
    },
    footer: {
        width: '100%',
        position: 'absolute',
        bottom: '30',
        left: '0',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: '0 30',
        alignItems: 'baseline',
    },
    smallLogo: {
        width: '10vw',
        height: '8vw',
    },
    pageNumbers: {
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
    },
    tableContainer: {
        marginTop: '5.5vw',
        width: '100%',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottom: `1 solid ${colors.greyPorcelain}`,
        minHeight: '32',
    },
    tableHeaderRow: {
        flexDirection: 'row',
        borderBottom: `1 solid ${colors.greyPorcelain}`,
        backgroundColor: '#F8F9FA',
        minHeight: '32',
    },
    tableHeaderCell: {
        padding: '8 12',
        backgroundColor: '#F8F9FA',
        minHeight: '32',
        display: 'flex',
        justifyContent: 'center',
    },
    tableHeaderText: {
        fontSize: '10',
        fontFamily: 'DemiBold',
        color: '#21282D',
        lineHeight: 1.4,
    },
    tableCell: {
        padding: '8 12',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '32',
    },
    tableCellText: {
        fontSize: '11',
        fontFamily: 'Regular',
        color: '#21282D',
        lineHeight: 1.5,
        marginBottom: '2',
    },
    spaceNameText: {
        fontSize: '12',
        fontFamily: 'DemiBold',
        color: '#21282D',
        lineHeight: 1.4,
        marginBottom: '2',
    },
    ratingText: {
        fontSize: '10',
        fontFamily: 'DemiBold',
        marginTop: '0',
        lineHeight: 1.4,
    },
    headerCell: {
        padding: '5',
    },
    firstColumn: {
        width: '33%',
    },
    valueColumn: {
        width: '22.33%',
    },
    deviceIcon: {
        width: '34',
        height: '34',
        padding: '5',
        marginTop: '3',
        marginLeft: '3',
    },
    sensorValue: {
        fontSize: '18',
        fontFamily: 'DemiBold',
    },
    sensorValueWrapper: {
        fontSize: '10',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
    },
    sensorUnitText: {
        fontSize: '7',
        paddingBottom: '3',
    },
    paddedAverage: {
        margin: '5 0',
    },
    valueWrapper: {
        paddingLeft: '2vw',
        paddingRight: '2vw',
    },
    paddedValueWrapper: {
        marginLeft: '50',
        paddingLeft: '2vw',
        paddingRight: '2vw',
    },
    viewSize: {
        width: '52vw',
    },
    sensorHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginTop: '2vw',
        marginBottom: '24',
        flexWrap: 'wrap',
    },
    sensorTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8',
    },
    sensorName: {
        fontSize: '20',
        fontFamily: 'DemiBold',
        color: '#21282D',
    },
    ratingLegend: {
        display: 'flex',
        flexDirection: 'row',
        gap: '4',
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
    },
    legendItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2',
        minWidth: '65',
        flex: '0 0 auto',
    },
    thresholdPill: {
        padding: '1 4',
        borderRadius: '8',
        minWidth: '30',
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    pillText: {
        fontSize: '7',
        fontFamily: 'DemiBold',
        lineHeight: 1.2,
        textAlign: 'center',
    },
    legendRange: {
        fontSize: '8',
        textAlign: 'center',
        color: '#3D3D3D',
        marginTop: '2',
        lineHeight: 1.3,
        fontFamily: 'Regular',
    },
    description: {
        fontSize: 11,
        fontFamily: 'Regular',
        fontStyle: 'normal',
        fontWeight: 400,
        marginTop: '0',
        marginBottom: '32',
        color: '#21282D',
        lineHeight: 1.5,
    },
    summaryCardsGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '16',
        marginBottom: '16',
    },
    summaryCard: {
        width: '48%',
        padding: '16',
        border: `1 solid ${colors.greyMist}`,
        borderRadius: '8',
        backgroundColor: '#FFFFFF',
        minHeight: '100',
    },
    summaryCardTitle: {
        fontSize: '10',
        fontFamily: 'Regular',
        marginBottom: '6',
        color: '#21282D',
        lineHeight: 1.4,
    },
    summaryCardValue: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        gap: '4',
        marginBottom: '8',
    },
    summaryValue: {
        fontSize: '28',
        fontFamily: 'DemiBold',
        color: '#21282D',
        lineHeight: 1.2,
    },
    summaryUnit: {
        fontSize: '10',
        color: '#21282D',
        lineHeight: 1.2,
    },
    summaryRating: {
        fontSize: '10',
        fontFamily: 'DemiBold',
        marginTop: '0',
        lineHeight: 1.4,
    },
    detailCard: {
        width: '48%',
        padding: '16',
        border: `1 solid ${colors.greyMist}`,
        borderRadius: '8',
        backgroundColor: '#FFFFFF',
        minHeight: '100',
    },
    detailCardHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8',
        marginBottom: '8',
    },
    detailCount: {
        fontSize: '12',
        fontFamily: 'DemiBold',
        color: '#21282D',
        lineHeight: 1.4,
    },
    detailLabel: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: '#21282D',
        marginBottom: '4',
        lineHeight: 1.4,
    },
    detailPeakRange: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: '#21282D',
        lineHeight: 1.4,
    },
    chartContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: '16',
        marginBottom: '24',
    },
    chartImage: {
        width: '100%',
        height: '180',
        objectFit: 'contain',
    },
    topSummaryCardsGrid: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '32',
        width: '100%',
    },
    summaryCardsRow: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginBottom: '18',
    },
    sensorSummaryItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: '1 1 0%',
        marginRight: '2%',
    },
    sensorSummaryContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: '6',
        flex: 1,
        minWidth: 0,
    },
    sensorSummaryHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '5',
        marginBottom: '0',
        flexWrap: 'nowrap',
        minWidth: 0,
        flexShrink: 1,
    },
    sensorSummaryName: {
        fontSize: '11',
        fontFamily: 'Regular',
        color: '#21282D',
        flexShrink: 1,
        minWidth: 0,
    },
    statusPill: {
        paddingTop: '1',
        paddingBottom: '3',
        paddingLeft: '6',
        paddingRight: '6',
        borderRadius: '12',
        minWidth: '30',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    statusPillText: {
        fontSize: '8',
        fontFamily: 'DemiBold',
        lineHeight: 1,
        textAlign: 'center',
        marginTop: '1',
    },
    sensorSummaryValue: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '4',
    },
    sensorSummaryValueText: {
        fontSize: '17',
        fontFamily: 'DemiBold',
        color: '#21282D',
        lineHeight: 1.2,
    },
    sensorSummaryUnit: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: '#21282D',
        lineHeight: 1.2,
    },
    metricCardIcon: {
        width: '18',
        height: '18',
        objectFit: 'contain',
    },
    metricCardName: {
        fontSize: '11',
        fontFamily: 'Regular',
        color: '#21282D',
    },
    metricCardValue: {
        fontSize: '17',
        fontFamily: 'DemiBold',
        color: '#21282D',
        lineHeight: 1.2,
    },
    metricCardUnit: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: '#21282D',
        lineHeight: 1.2,
    },
    co2LegendContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: '48',
        marginBottom: '32',
    },
    co2LegendHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8',
        marginBottom: '16',
    },
    co2LegendLabel: {
        fontSize: '14',
        fontFamily: 'Regular',
        color: '#21282D',
    },
    co2LegendItems: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16',
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
    },
    co2LegendItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '4',
        minWidth: '80',
        flex: '0 0 auto',
    },
    co2LegendPill: {
        padding: '4 12',
        borderRadius: '16',
        minWidth: '55',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    co2LegendPillText: {
        fontSize: '10',
        fontFamily: 'DemiBold',
        lineHeight: 1.2,
        textAlign: 'center',
    },
    co2LegendRange: {
        fontSize: '8',
        fontFamily: 'Regular',
        color: '#3D3D3D',
        textAlign: 'center',
        lineHeight: 1.3,
        marginTop: '4',
    },
    buildingDetailsGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '3vw',
    },
    buildingDetailItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5vw',
    },
    openingHoursDayItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5vw',
    },
    buildingDetailLabel: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: '#8C9BA8',
    },
    buildingDetailValue: {
        fontSize: '10',
        fontFamily: 'Regular',
        color: '#21282D',
    },
    noDataContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24',
        marginTop: '16',
        marginBottom: '16',
    },
    noDataText: {
        fontSize: '11',
        fontFamily: 'Regular',
        color: '#8C9BA8',
        textAlign: 'center',
    },
});

export default iaqInsight2PdfStyles;
